





































import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component
export default class InputFormMailInquiry extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ required: true })
  email1: string

  @Prop({ required: true })
  email2: string

  @Prop({ required: true })
  input: (value: string, field: string) => void
}
